var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cms-pricing-block" }, [
    _c(
      "div",
      { staticClass: "cms-pricing-block__card", style: _vm.cardStyle },
      [
        _vm.ribbonText
          ? _c(
              "div",
              {
                staticClass: "cms-pricing-block__ribbon",
                style: _vm.ribbonStyle,
              },
              [_vm._v("\n\t\t\t" + _vm._s(_vm.ribbonText) + "\n\t\t")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.icon
          ? _c(
              "div",
              {
                staticClass: "cms-pricing-block__icon-wrap",
                style: _vm.iconWrapStyle,
              },
              [_c("i", { class: "fa fa-" + _vm.icon, style: _vm.iconStyle })]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.planName
          ? _c(
              "div",
              { staticClass: "cms-pricing-block__plan", style: _vm.planStyle },
              [_vm._v(_vm._s(_vm.planName))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.tagline
          ? _c(
              "div",
              {
                staticClass: "cms-pricing-block__tagline",
                style: _vm.taglineStyle,
              },
              [_vm._v(_vm._s(_vm.tagline))]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "cms-pricing-block__divider",
          style: _vm.dividerStyle,
        }),
        _vm._v(" "),
        _c("div", { staticClass: "cms-pricing-block__price-wrap" }, [
          _vm.originalPrice
            ? _c(
                "span",
                {
                  staticClass: "cms-pricing-block__original-price",
                  style: _vm.originalPriceStyle,
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.currencySymbol) +
                      _vm._s(_vm.originalPrice) +
                      "\n\t\t\t"
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "cms-pricing-block__price", style: _vm.priceStyle },
            [
              _c("span", { staticClass: "cms-pricing-block__currency" }, [
                _vm._v(_vm._s(_vm.currencySymbol)),
              ]),
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.price) + "\n\t\t\t"),
            ]
          ),
          _vm._v(" "),
          _vm.pricePeriod
            ? _c(
                "span",
                {
                  staticClass: "cms-pricing-block__period",
                  style: _vm.periodStyle,
                },
                [_vm._v("/ " + _vm._s(_vm.pricePeriod))]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.parsedFeatures.length
          ? _c(
              "ul",
              {
                staticClass: "cms-pricing-block__features",
                style: _vm.featuresStyle,
              },
              _vm._l(_vm.parsedFeatures, function (feature, idx) {
                return _c(
                  "li",
                  {
                    key: idx,
                    staticClass: "cms-pricing-block__feature",
                    class: {
                      "cms-pricing-block__feature--disabled": feature.disabled,
                    },
                    style: _vm.featureStyle(feature),
                  },
                  [
                    _c("i", {
                      staticClass: "fa cms-pricing-block__feature-icon",
                      class: feature.disabled ? "fa-times" : "fa-check",
                      style: _vm.featureIconStyle(feature),
                    }),
                    _vm._v("\n\t\t\t\t" + _vm._s(feature.text) + "\n\t\t\t"),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "cms-pricing-block__divider",
          style: _vm.dividerStyle,
        }),
        _vm._v(" "),
        _c("div", { staticClass: "cms-pricing-block__cta-wrap" }, [
          _c(
            "a",
            {
              staticClass: "cms-pricing-block__cta",
              style: _vm.buttonStyle,
              attrs: { href: _vm.buttonUrl || "#" },
            },
            [
              _vm.buttonIcon
                ? _c("i", { class: "fa fa-" + _vm.buttonIcon })
                : _vm._e(),
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.buttonLabel || "Get Started") +
                  "\n\t\t\t"
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.footerNote
          ? _c(
              "div",
              { staticClass: "cms-pricing-block__note", style: _vm.noteStyle },
              [_vm._v(_vm._s(_vm.footerNote))]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }